import { cn } from "@/lib/utils";

const STORM_COLORS = {
  thundery_showers: "#E6D8AD",
  weak: "#A8CFB6",
  moderate: "#E9D85A",
  strong: "#F89C27",
  severe: "#F33D14",
  violent: "#B45AA9"
};

const STORM_NAMES = {
  thundery_showers: "Thundery Showers",
  weak: "Weak",
  moderate: "Moderate",
  strong: "Strong",
  severe: "Severe",
  violent: "Violent"
};

export function StormTypeBadge({ type, size = "default", className }) {
  const color = STORM_COLORS[type] || "#9CA3AF";
  const name = STORM_NAMES[type] || type;
  
  return (
    <span
      className={cn(
        "inline-flex items-center font-semibold uppercase tracking-wide",
        size === "small" ? "px-2 py-0.5 text-[9px]" : "px-3 py-1 text-[10px]",
        className
      )}
      style={{
        color: color,
        backgroundColor: `${color}15`,
        border: `1px solid ${color}50`
      }}
      data-testid={`storm-badge-${type}`}
    >
      <span 
        className={cn(
          "rounded-full mr-1.5",
          size === "small" ? "w-1.5 h-1.5" : "w-2 h-2"
        )}
        style={{ backgroundColor: color }}
      />
      {name}
    </span>
  );
}

export function StormTypeLegend({ types, className }) {
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {types.map((type) => (
        <StormTypeBadge key={type} type={type} />
      ))}
    </div>
  );
}

export function FullStormLegend({ className }) {
  const allTypes = Object.keys(STORM_COLORS);
  
  return (
    <div className={cn("space-y-3", className)}>
      <h4 className="font-heading text-xs uppercase tracking-widest text-[#6B7280]">
        Thunderstorm Type Scale
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {allTypes.map((type) => (
          <div 
            key={type}
            className="flex items-center gap-2 p-2 bg-[#111827] border border-white/5"
          >
            <span 
              className="w-4 h-4 flex-shrink-0"
              style={{ backgroundColor: STORM_COLORS[type] }}
            />
            <span className="text-xs text-[#F9FAFB] uppercase tracking-wide">
              {STORM_NAMES[type]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export { STORM_COLORS, STORM_NAMES };
